import styles from './input.module.scss';

interface InputProps {
  label?: string;
  value: string;
  placeholder: string;
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
}

const Input: React.FC<InputProps> = ({ label, placeholder, value, className, onChange, onFocus }) => {
  const classes = `
  ${styles.input} 
  ${className || ''}`.trim();

  return (
    <div className={classes}>
      {!!label && <span className={styles.label}>{label}</span>}
      <input placeholder={placeholder} onChange={onChange} value={value} onFocus={onFocus}/>
    </div>
  );
};

export default Input;
